import React from 'react';
import { TOURNAMENT_STATUSES } from 'core/constants';

import { Main } from 'components/main/main';
import { HeadHelmet } from 'components/head-helmet/head-helmet';
import { PromoTournaments } from 'components/promo-tournaments/promo-tournaments';

import { PAGE_NAMES } from '../../constants';

import './tournaments.scss';

const Tournaments = () => (
  <Main>
    <HeadHelmet page={PAGE_NAMES.TOURNAMENTS} />

    <PromoTournaments
      coreProps={{
        availableStatuses: [
          TOURNAMENT_STATUSES.ACTIVE,
          TOURNAMENT_STATUSES.PENDING,
          TOURNAMENT_STATUSES.AWARDED,
        ],
      }}
      isTournamentsPage
      isOnlyCardType
    />
  </Main>
);

export default Tournaments;
